import type { ReactNode } from "react";
import { lineClamp } from "~/common/components/icon/FontUtils";
import { Box, Stack, styled, Tooltip, Typography } from "~/common/mui";

export const Param = ({
  label,
  value,
  footer,
}: {
  label?: React.ReactNode;
  value: React.ReactNode;
  footer?: React.ReactNode;
}) => {
  const isTextValue = typeof value === "string" || typeof value === "number";

  const isTextFooter = typeof footer === "string" || typeof footer === "number";

  return (
    <Stack gap={0.5} alignItems={"flex-start"}>
      {label && (
        <Typography variant="bodySmall" color="text.label">
          {label}
        </Typography>
      )}

      {isTextValue ? (
        <TruncatedText variant="bodyLarge" color="text.secondary">
          {value ?? "-"}
        </TruncatedText>
      ) : (
        value ?? "-"
      )}

      {footer &&
        (isTextFooter ? (
          <TruncatedText variant="bodySmall" color="text.secondary">
            {footer}
          </TruncatedText>
        ) : (
          footer
        ))}
    </Stack>
  );
};

const TruncatedText = styled(Typography)({
  ...lineClamp(1),
  width: "100%",
  alignSelf: "flex-start",
});

interface TooltipParamProps {
  label: ReactNode;
  value: ReactNode;
  tooltipContent: ReactNode;
  footer?: ReactNode;
}

export const TooltipParam = ({ label, value, tooltipContent, footer }: TooltipParamProps) => (
  <Box alignSelf="flex-start">
    <Tooltip
      variant="rich"
      title={tooltipContent}
      placement="top"
      arrow
      slotProps={{
        tooltip: {
          sx: {
            width: 240,
            maxWidth: 240,
          },
        },
      }}
    >
      <Box display={"inline-flex"}>
        <Param label={label} value={value} footer={footer} />
      </Box>
    </Tooltip>
  </Box>
);
